import { exists } from '@/api'

export interface BibliographyDetailAuthority {
  tag: string
  authorityNo: string
  authorityTag: string
  data: string
}

export function BibliographyAuthorityFromJSON(
  json: any
): BibliographyDetailAuthority {
  return {
    tag: exists(json, 'tag') ? json.tag : '',
    authorityNo: exists(json, 'authority_no') ? json.authority_no : '',
    authorityTag: exists(json, 'authority_tag') ? json.authority_tag : '',
    data: exists(json, 'data') ? json.data : ''
  }
}
